module.exports = __webpack_public_path__ + "img/v23.a898fd7b.jpg";